<div>
  @if (dialogTitle) {
    <span class="bigger-font marg-bot8">{{ dialogTitle }}</span>
  }
  <div class="dialog-searchbar-wrapper">
    <mat-form-field class="w100" appearance="outline">
      <mat-label>Suche</mat-label>
      <input (input)="search()" [formControl]="searchControl" matInput placeholder="">
    </mat-form-field>
  </div>
</div>
<div class="custom-scrollbar scrollable-table">
  <table [dataSource]="matchingData" mat-table class="w100 table pad4">


    <!-- Checkbox multi select Column -->
    <ng-container matColumnDef="multi-select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? toggleAllRows() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()" color="primary">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? changeSelection(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)" color="primary">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Checkbox single select Column -->
    <ng-container matColumnDef="single-select">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-radio-button (change)="$event ? changeSelection(row) : null"
          (click)="$event.stopPropagation()"
          [aria-label]="checkboxLabel(row)"
          [checked]="selection.isSelected(row)" color="primary">
        </mat-radio-button>
      </td>
    </ng-container>


    <ng-container matColumnDef="id">
      <th *matHeaderCellDef mat-header-cell> ID</th>
      <td *matCellDef="let element" mat-cell> {{ element.id }}</td>
    </ng-container>

    <!--------------- Vocabulary Category Columns --------------->
    <ng-container matColumnDef="voc-cat-name">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Parent Column -->
    <ng-container matColumnDef="voc-cat-parent">
      <th *matHeaderCellDef mat-header-cell> Überthema</th>
      <td *matCellDef="let element" mat-cell> {{ element.parentName }}</td>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="voc-cat-type">
      <th *matHeaderCellDef mat-header-cell> Typ</th>
      <td *matCellDef="let element"
        mat-cell> {{ (element.isWordField ? 'Wortfeld' : (element.isDach ? 'DACH-Feld' : '')) }}
      </td>
    </ng-container>

    <!--------------- Vocabulary Entry Columns --------------->
    <ng-container matColumnDef="voc-ent-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Category Column-->
    <ng-container matColumnDef="voc-ent-cat">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.categoryName }}</td>
    </ng-container>

    <!-- Type Column NOT USED -->
    <ng-container matColumnDef="voc-ent-type">
      <th *matHeaderCellDef mat-header-cell> Wortart</th>
      <td *matCellDef="let element" mat-cell> {{ typeEnumToString(element.type) }}</td>
    </ng-container>

    <!-- Comment Column NOT USED-->
    <ng-container matColumnDef="voc-ent-comment">
      <th *matHeaderCellDef mat-header-cell> Kommentar</th>
      <td *matCellDef="let element" mat-cell> {{ element.comment }}</td>
    </ng-container>

    <!--------------- Sys Grammar Entry Columns --------------->
    <ng-container matColumnDef="sys-ent-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Category Column-->
    <ng-container matColumnDef="sys-ent-cat">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.categoryName }}</td>
    </ng-container>

    <!--------------- Sys Grammar Category Columns --------------->
    <ng-container matColumnDef="sys-cat-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Parent Column-->
    <ng-container matColumnDef="sys-cat-parent">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.parentName }}</td>
    </ng-container>

    <!--------------- Fun Grammar Entry Columns --------------->
    <ng-container matColumnDef="fun-ent-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Category Column-->
    <ng-container matColumnDef="fun-ent-cat">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.categoryName }}</td>
    </ng-container>

    <!--------------- Fun Grammar Category Columns --------------->
    <ng-container matColumnDef="fun-cat-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Parent Column-->
    <ng-container matColumnDef="fun-cat-parent">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.parentName }}</td>
    </ng-container>

    <!--------------- Text Type Columns --------------->
    <ng-container matColumnDef="text-type-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Parent Column-->
    <ng-container matColumnDef="text-type-type">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.mode }}</td>
    </ng-container>

    <!--------------- Text patterns Columns --------------->
    <ng-container matColumnDef="text-pattern-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Parent Column-->
    <ng-container matColumnDef="text-pattern-type">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ getMode(element) }}</td>
    </ng-container>

    <!---------------  Detailed can do descriptions Columns --------------->
    <ng-container matColumnDef="det-can-ent-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Parent Column-->
    <ng-container matColumnDef="det-can-ent-cat">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.parentName }}</td>
    </ng-container>

    <!---------------  Detailed can do descriptions category Columns --------------->
    <ng-container matColumnDef="det-can-cat-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Parent Column-->
    <ng-container matColumnDef="det-can-cat-parent">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.parentName }}</td>
    </ng-container>

    <!---------------  Global can do descriptions Columns --------------->
    <ng-container matColumnDef="glob-can-ent-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Parent Column-->
    <ng-container matColumnDef="glob-can-ent-cat">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.parentName }}</td>
    </ng-container>

    <!---------------  Global can do descriptions Columns --------------->
    <ng-container matColumnDef="glob-can-cat-name">
      <th *matHeaderCellDef mat-header-cell> Wort</th>
      <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
    </ng-container>

    <!-- Parent Column-->
    <ng-container matColumnDef="glob-can-cat-parent">
      <th *matHeaderCellDef mat-header-cell> Thema</th>
      <td *matCellDef="let element" mat-cell> {{ element.parentName }}</td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr (click)="changeSelection(row)" *matRowDef="let row; columns: displayedColumns;"
      mat-row>
    </tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="3"><h4 class="no-data-row-text">Keine Suchergebnisse gefunden </h4></td>
    </tr>
  </table>
  @if (isLoadingResults) {
    <div class="center-content pad16">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }
</div>
<div class="dialog-button-group">
  <button (click)="deselectObject()" mat-raised-button>
    Auswahl widerrufen
  </button>
  <mat-paginator [length]="resultsLength" [pageSize]="25" style="width: fit-content" showFirstLastButtons></mat-paginator>
</div>
